export default __webpack_public_path__ + "static/media/company.bf1b409a.svg";